import type { RemoteSkillInstallItem } from './types.js';

export function isValidRemoteSkillInstallItem(item: unknown): item is RemoteSkillInstallItem {
  if (item === null || typeof item !== 'object') return false;
  const o = item as RemoteSkillInstallItem;
  return (
    typeof o.sourceId === 'string' &&
    typeof o.skillName === 'string' &&
    typeof o.versionHash === 'string' &&
    Array.isArray(o.files)
  );
}
